/**
 * MSAL configuration for the JM Test Atlas frontend.
 *
 * Creates the PublicClientApplication and scope request objects using the
 * shared @jmtest/auth/client factory, then re-exports them so the rest of
 * the app can continue using the same named imports as before.
 */
import { createMsalClient } from '@jmtest/auth/client';

const clientId = import.meta.env.VITE_AZURE_CLIENT_ID as string;
const tenantId = import.meta.env.VITE_AZURE_TENANT_ID as string;
const redirectUri = (import.meta.env.VITE_REDIRECT_URI as string) || window.location.origin;

// createMsalClient is async (calls msalInstance.initialize()), so we
// initialise at module level with a top-level await — Vite supports this.
const msal = await createMsalClient({
  clientId,
  tenantId,
  redirectUri,
  verbose: import.meta.env.DEV,
});

export const msalInstance            = msal.msalInstance;
export const loginRequest            = msal.loginRequest;
export const apiRequest              = msal.apiRequest;
export const graphRequest            = msal.graphRequest;
export const acquireToken            = msal.acquireToken;
export const acquireGraphTokenSilent = msal.acquireGraphTokenSilent;
export const acquireGraphToken       = msal.acquireGraphToken;
export const reauthorize             = msal.reauthorize;
